import qaContent from './content.qa';

export default qaContent;
